import { useState } from "react"
import { CopDocumentImportProgress } from "./server/cop-events.mjs"

const TERMINAL_TYPES = new Set(["success", "warn"])

/**
 * Tracks which documents are currently being imported by listening to
 * CopDocumentImportProgress events. A document is active from the first
 * progress message until a terminal type ("success" or "warn") arrives.
 *
 * @returns {Set<string>} Set of currently-active document IDs
 */
export function useActiveDocumentIds() {
    const [activeIds, setActiveIds] = useState(() => new Set())

    CopDocumentImportProgress.useEvent(handleProgress, [])

    return activeIds

    function handleProgress({ documentId, type }) {
        setActiveIds((prev) => {
            const next = new Set(prev)
            if (TERMINAL_TYPES.has(type)) {
                next.delete(documentId)
            } else {
                next.add(documentId)
            }
            return next
        })
    }
}
